import { CandidateWarning } from './browserWarnings';
import { Observation, ObservationSource } from '../types/domain';

export function observationSourceLabel(source: ObservationSource): string {
  if (source === 'laptop-camera') return 'Laptop camera';
  if (source === 'mobile-camera') return 'Secondary camera';
  if (source === 'network') return 'Connection';
  return 'Monitoring';
}

export function monitoringNoticeDecision(
  observation: Observation,
  previousStatus: Observation['status'] | undefined,
  previousWarningAt: number,
  now: number,
  cooldownMs: number
): { notice?: CandidateWarning; playAudio: boolean } {
  if (observation.status === previousStatus || (observation.status !== 'active' && observation.status !== 'recovered')) {
    return { playAudio: false };
  }
  const recovered = observation.status === 'recovered';
  if (!recovered && now - previousWarningAt < cooldownMs) return { playAudio: false };
  return {
    notice: {
      id: `${observation.id}-${observation.status}-${observation.occurrenceCount}`,
      eventType: observation.type,
      timestamp: observation.lastUpdatedAt,
      message: recovered ? `${observationSourceLabel(observation.source)} restored.` : observation.message,
      tone: recovered ? 'green' : observation.importance === 'important' ? 'orange' : 'yellow',
      title: recovered ? 'Condition recovered' : 'Attention needed'
    },
    playAudio: !recovered
  };
}
